import { action } from "typesafe-actions";

import { PlacesActionTypes, PlacesRequest, PlacesSearchResultCallback } from "./types";

export const placesFetchRequest = (request: PlacesRequest & PlacesSearchResultCallback) =>
  action(PlacesActionTypes.PLACES_FETCH_REQUEST, request);
